// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-block-container{padding:48px 24px}@media (min-width:768px){.text-block-container{padding-left:5vw;padding-right:5vw}}.text-block-grid{display:grid;grid-template-columns:repeat(12,minmax(0,1fr))}@media (min-width:640px){.text-block-grid{-moz-column-gap:16px;column-gap:16px}}@media (min-width:768px){.text-block-grid{-moz-column-gap:48px;column-gap:48px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
